<template>
  <!-- <div class="white_space"> -->

  <div class="nucleicAcidTestMaind" ref="nucleicAcidTestMain">
    <van-nav-bar
      :class="flag ? 'trans' : 'notr'"
      title="教育缴费"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <!-- <van-search
      v-model="value"
      shape="round"
      placeholder="请输入收费项关键词"
    /> -->
    <div class="paySearch">
      <img
        class="searchPic"
        :src="require('../../assets/img/searchLog.png')"
        alt=""
      />
      <van-field
        placeholder="请输入收费项关键词"
        v-model="value"
        type="input"
      />
    </div>

    <van-radio-group v-model="chargeIds">
      <div
        @click="toPay($event, item, index)"
        class="pbox"
        v-for="(item, index) in searchLis"
        :key="item.uId"
        :ref="item.uId"
      >
        <!-- <van-radio :name="item.uId"></van-radio> -->
        <SelfEduPay
          @toggle="item.showIt = false"
          :showDL="item.showIt"
          :pay-info="item"
        />
      </div>

      <div v-if="eduInfo && eduInfo.enable">
        <div
          v-if="!chargeList || chargeList.length == 0"
          class="noticeMessEnter"
        >
          若该页面无缴纳的费用，可点击<br />跳转<span
            class="enter"
            @click="toSelfPay"
            >自助查询缴费</span
          >缴纳
        </div>
        <div class="noticeMessEnter" v-else>
          若该页面无缴纳的费用，可点击跳转<span class="enter" @click="toSelfPay"
            >自助查询缴费</span
          >缴纳
        </div>
      </div>
      <div v-else class="noticeMessEnter">
        若该页面无应缴收费项，请联系执收单位。
      </div>
    </van-radio-group>
    <div id="widget" />

    <div class="btnBoxPay">
      <div class="totalWord">
        <div>{{ checkedList ? "" : "" }}</div>
        <span class="word">总计：</span>
        <span class="mon">¥ {{ total }}</span>
      </div>
      <van-button
        round
        block
        type="info"
        @click="contPay(chargeIds)"
        class="btn"
        >支付</van-button
      >
    </div>

    <!-- <div class="bot">
      <div>&nbsp;</div>
      <div class="total">
        <span class="b_tot">已选{{ checkedList ? 1 : 0 }}项,合计：</span
        ><span class="b_total"><span class="yang">¥</span>{{ total }}</span>
        <van-button class="b_btn" @click="contPay(chargeIds)" round type="info"
          >支 付</van-button
        >
      </div>
    </div> -->
    <PayNotice
      :isShowDetail="showDialog"
      @closeDialog="closeDia"
      @payContinue="payContinue"
      :payInfo="currentPayData"
    ></PayNotice>
    <!-- <div class="pbottom">
      合计从 选中的子组件中计算得来
      <div>
        合计(元):<span>{{total}}</span
        ><span>({{ checkedList ? 1 : 0 }}项)</span>
      </div>
      <button @click="contPay(chargeIds)">支付</button>
    </div> -->
    <GoQueryDialog
      :show="showConfirm"
      :notice="confirmMsg"
      :action="action"
      @close="confirmAction"
    ></GoQueryDialog>

    <ErrorNotice
      @close="showErr = false"
      :show="showErr"
      :notice="notice"
    ></ErrorNotice>
  </div>
  <!-- </div> -->
</template>

<script>
import { isEmpty, publicEncrypt } from "@/utils/common.js";
import SelfEduPay from "@/components/selfEduPayList.vue";
import { Dialog, Toast } from "vant";
// import { RadioGroup, Radio } from "vant";
import { judgeVde } from "@/utils/publicJudge";
import PayNotice from "@/components/dialog/payNoticeDialog.vue";
import GoQueryDialog from "./components/goQueryDialog.vue";
import ErrorNotice from "@/components/dialog/errorNotice";

let loadedMineMapJs = false;

export default {
  data() {
    return {
      configFlag: false,
      showErr: false,
      notice: "",
      showConfirm: false,
      confirmMsg: "",
      action: "",
      bool: false,
      showDialog: false,
      showIt: false,
      check: false,
      info: null,
      out: {},
      vde: "",
      value: "",
      payList: null, // 保存已选中的收费项
      checkList: [],
      total: 0.0,
      isPay: false,
      searchList: [],
      chargeIds: "",
      showChooseCharge: false, // 控制选择缴费的弹窗是否显示
      chargeList: [], // 学校收费项列表
      chargeMap: [], // 学校收费项
      payBody: {
        //选中学校收费项相关信息
        chargeId: "",
        period: "", //费用年度
        quarterName: "", // 费用季度
        actualTotal: "", //个人应收总额
        startDate: "", //费用开始时间
        endDate: "", //费用截止时间
        studentId: "", //缴费人
      },
      chargeName: "",
      currentPayData: null,
      queryD: "",
      flag: false,
      isWxmp: false,
      eduInfo: {},
    };
  },
  computed: {
    checkedList() {
      // console.log(this.payList);
      // console.log(this.$store.state.pplist.payList);
      let lis = this.payList;
      this.total = (0.0).toFixed(2);
      if (lis && lis.uId) {
        // console.log(lis);
        this.total = parseFloat(this.total);
        this.total += parseFloat(lis.actualTotal);
        this.total = parseFloat(this.total).toFixed(2);
      }
      return lis;
    },
    searchLis() {
      // 模糊查询前端所有满足搜索关键字的收费项
      if (!isEmpty(this.value)) {
        this.searchList = [];
        this.chargeList.forEach((item) => {
          if (item.chargeName.indexOf(this.value) != -1) {
            this.searchList.push(item);
          }
        });
      } else {
        this.searchList = this.chargeList;
      }
      this.searchList.forEach((item) => {
        this.$set(item, "showIt", false);
      });
      return this.searchList;
    },
  },
  // 待缴费项
  components: {
    SelfEduPay,
    PayNotice,
    GoQueryDialog,
    ErrorNotice,
  },
  methods: {
    confirmAction(val) {
      this.showConfirm = false;
      if (val.action == "goQuery" && val.flag) {
        let obj1 = {
          routeName: "selfEduPrePayList", //路由名称（毕传）
          uId: this.info.uId, //其他参数为你需要的
          deptId: this.info.deptId,
          vde: this.vde,
          name: this.info.name,
          idCard: this.info.idCard,
          out: sessionStorage.getItem("out"),
        };
        localStorage.setItem("payRouteBack", JSON.stringify(obj1));
        window.localStorage.setItem("fromEdu", "1");
        // console.log(obj);
        let obj = this.queryD;
        //跳转到查询页面
        let str = JSON.stringify({
          paymentUnit: obj.name,
          idCard: obj.idCard,
          fromtype: "1",
        });
        window.localStorage.setItem("searchInfo", str);
        let s = publicEncrypt(str);
        this.$router.push({
          path: "/pages/results/results?vde=" + this.vde + "&s=" + s,
        });
      } else if (val.action == "goQuery" && !val.flag) {
      }
    },

    toSelfPay() {
      let obj = this.queryD;
      let obj1 = {
        routeName: "selfEduPrePayList", //路由名称（毕传）
        uId: this.info.uId, //其他参数为你需要的
        deptId: this.info.deptId,
        vde: this.vde,
        name: this.info.name,
        idCard: this.info.idCard,
        out: sessionStorage.getItem("out"),
      };
      localStorage.setItem("payRouteBack", JSON.stringify(obj1));
      // console.log(obj);
      //跳转到查询页面
      let str = JSON.stringify({
        paymentUnit: obj.name,
        idCard: obj.idCard,
        fromtype: "1",
      });
      window.localStorage.setItem("fromEdu", "1");
      window.localStorage.setItem("searchInfo", str);
      // 加密搜索条件
      let s = publicEncrypt(str);
      this.$router.push({
        path: "/pages/results/results?vde=" + this.vde + "&s=" + s,
      });
    },
    closeDia() {
      this.showDialog = false;
    },
    payContinue() {
      this.showDialog = false;
      this.chargePay();
    },
    pay(data) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      // 请求支付接口
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/epay/pay_init",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else {
          Toast.clear();

          // this.showErr = true;
          // this.notice = res.data.message;
          let str = "确认";
          if (res.data.errorMessage) {
            str = "查看错误详情";
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            }).then(() => {
              this.$CTips({
                title: "错误提示",
                message: res.data.errorMessage,
                clickOverlay: false,
              });
            });
          } else {
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            });
          }
          this.usepay = true;

          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // }).then(() => {
          //   this.usepay = true;
          // });
        }
      });
    },
    remitPayRequest(data) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      // 请求支付接口
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/merger/remit_pay",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else {
          Toast.clear();
          // this.showErr = true;
          // this.notice = res.data.message;
          let str = "确认";
          if (res.data.errorMessage) {
            str = "查看错误详情";
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            }).then(() => {
              this.$CTips({
                title: "错误提示",
                message: res.data.errorMessage,
                clickOverlay: false,
              });
            });
          } else {
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            });
          }
          this.usepay = true;

          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // }).then(() => {
          //   this.usepay = true;
          // });
        }
      });
    },
    // 支付
    initPay(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no,
      };
      let that = this;
      const interval = setInterval(() => {
        if (loadedMineMapJs) {
          // this.
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          Toast.clear();
          that.isPay = false;
        }
      }, 100);
    },
    otherPay(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no,
      };
      // 微信小程序中，多加几个参数
      // if (this.isWxmp) {
      //     this.$set(obj,'paymentName',res.paymentName)
      //     this.$set(obj,'itemNameSet',res.itemNameSet)
      // }
      let that = this;
      const interval = setInterval(() => {
        if (loadedMineMapJs) {
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          // Toast.clear();
          // that.usepay = true;
        }
      }, 100);
    },
    toPay(e, obj, index) {
      this.searchList.forEach((item) => {
        item.showIt = false;
      });
      // 先将所有的选项清除 check
      // let boxs = document.getElementsByClassName("pbox");
      // for (var i = 0; i < boxs.length; i++) {
      //   boxs[i].className = "pbox";
      // }
      obj.showIt = true;
      // boxs[index].className = "pbox sele";

      if (this.payList) {
        this.payList = null;
      }
      this.chargeIds = obj.uId;
      this.payList = { ...obj };
    },
    goChoosePay: function (obj, index) {
      this.resetPayBody();
      this.queryD = obj;
      this.isPay = false;
      // if(this.chargeList.length <=0){
      this.request({
        url: "/prepaid/listPrepaidChargeByDeptId",
        method: "get",
        params: { deptId: obj.deptId, studentId: obj.uId },
      }).then((res) => {
        this.chargeList = [];
        this.chargeMap = new Map();
        if (res.data.code == 1000) {
          if (res.data.result == null || res.data.result.length <= 0) {
            Toast.clear();
            // 获取配置进行判断是否展示
            // 先获取配置回显
            this.request({
              url: "/systemManage/getMobileFunConfig",
              method: "get",
              params: {
                deptId: obj.deptId,
                businessType: "eduSelfPayment",
              },
            }).then((res) => {
              if (res.data.code === 1000) {
                if (res.data.result) {
                  // 获取开关的值
                  if (
                    res.data.result.funcation &&
                    res.data.result.funcation.length > 0
                  ) {
                    this.eduInfo = res.data.result.funcation[0];
                    if (this.eduInfo && this.eduInfo.enable) {
                      this.showConfirm = true;
                      this.confirmMsg =
                        "当前所在单位暂无可缴费收费项<br/>请尝试使用查询缴费功能";
                      this.action = "goQuery";
                    }
                  }
                } else {
                  this.$CDialog({
                    confirmBtnText: "确认",
                    title: "提示",
                    status: "2",
                    textSize: 16,
                    message: "查询入口开关数据为空",
                  }).then((res) => {});
                }
              } else {
                this.$CDialog({
                  confirmBtnText: "确认",
                  title: "提示",
                  status: "2",
                  textSize: 16,
                  message: res.data.message,
                }).then((res) => {});
              }
            });

            // Dialog.confirm({
            //   title: "提示",
            //   message:
            //     "当前所在单位暂无可缴费收费项<br/>请尝试使用查询缴费功能",
            //   confirmButtonText: "去查询",
            //   cancelButtonText: "再等等",
            //   getContainer: ".nucleicAcidTestMaind",
            // })
            //   .then(() => {})
            //   .catch(() => {});
            // this.showChooseCharge = false;
          } else {
            this.request({
              url: "/systemManage/getMobileFunConfig",
              method: "get",
              params: {
                deptId: obj.deptId,
                businessType: "eduSelfPayment",
              },
            }).then((res) => {
              if (res.data.code === 1000) {
                if (res.data.result) {
                  // 获取开关的值
                  if (
                    res.data.result.funcation &&
                    res.data.result.funcation.length > 0
                  ) {
                    this.eduInfo = res.data.result.funcation[0];
                  }
                } else {
                  this.$CDialog({
                    confirmBtnText: "确认",
                    title: "提示",
                    status: "2",
                    textSize: 16,
                    message: "查询入口开关数据为空",
                  }).then((res) => {});
                }
              } else {
                this.$CDialog({
                  confirmBtnText: "确认",
                  title: "提示",
                  status: "2",
                  textSize: 16,
                  message: res.data.message,
                }).then((res) => {});
              }
            });
            this.chargeList = res.data.result;
            for(let idx=0;idx<this.chargeList.length;idx++){
              if (this.chargeList[idx].isCampusCard == "1" || this.chargeList[idx].isWxPush == "1") {
                let isWx = this.isWx();
                console.log(this.isWxmp);
                if (isWx) {
                  this.getBindQuery(false);
                  break;
                } else if (this.isWxmp) {
                  this.getBindQuery(true);
                  break;
                }
              }
            }

            this.showChooseCharge = true;
            let m = new Map();
            this.chargeList.forEach((c) => {
              m.set(c.uId, c);
              c.text = c.chargeName;
            });
            this.chargeMap = m;
            this.payBody.studentId = obj.uId;
          }
        } else {
          Toast.clear();
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: res.data.message,
          }).then((res) => {});
          this.showChooseCharge = false;
          return;
        }
      });
      // }else{   返回按钮颜色， 支付提示弹窗头部颜色，携带参数从 params中获取
      //     this.payBody.studentId = obj.uId
      //     //弹框
      //     this.showChooseCharge = true
      // }
    },
    isWx() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1; //通用
    },
    getBindQuery(flag) {
      let openId = "";
      let appid = "";
      if (localStorage.getItem(this.vde + "opendID")) {
        openId = localStorage.getItem(this.vde + "opendID");
      }
      if (localStorage.getItem("appId")) {
        appid = localStorage.getItem("appId");
      }
      if (openId && appid) {
        this.request({
          url: "/mobile/queryWxBind",
          method: "get",
          params: {
            vde: this.vde ? this.vde : "",
            appId: appid,
            wxOpenId: openId,
            confirmType:  "0",
            idCard: this.info.idCard,
            paymentUnit:this.info.name,
          },
        }).then((res) => {
          if (res.data.code == 1000) {
            // Toast({ message: res.data.message, icon: "none" });
          } else {
            // Dialog.alert({
            //   title: "提示",
            //   message: res.data.message,
            // }).then(() => {});
            // this.showErr = true;
            // this.errCon = res.data.message;
            let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message,
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false,
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message,
              });
            }
          }
        });
      }
    },
    // 选择收费项后去支付
    chargePay() {
      this.isPay = true;
      if (isEmpty(this.payBody.chargeId)) {
        Toast.clear();
        // Dialog.alert({
        //   title: "错误提示",
        //   message: "请选择需要支付的收费项",
        // }).then(() => {
        //   this.isPay = false;
        // });
        // this.showErr = true;
        // this.notice = "请选择需要支付的收费项";
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "请选择需要支付的收费项",
        }).then((res) => {});
        this.isPay = false;
        return;
      } else {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0,
        });
        setTimeout(() => {
            Toast.clear();
        }, 2000);
        this.request({
          baseURL: process.env.VUE_APP_PAY_URL,
          url: "/pay/payInitPrepaid",
          method: "post",
          data: {
            chargeId: this.payBody.chargeId,
            studentId: this.payBody.studentId,
          },
        }).then((res) => {
          // console.log(res);
          if (res.data.code == 1000) {
            let obj1 = {
              routeName: "selfEduPrePayList", //路由名称（毕传）
              uId: this.info.uId, //其他参数为你需要的
              deptId: this.info.deptId,
              name: this.info.name,
              idCard: this.info.idCard,
              vde: this.vde,
              out: sessionStorage.getItem("out"),
            };
            localStorage.setItem("payRouteBack", JSON.stringify(obj1));
            let result = res.data.result;
            if (result.length > 1) {
              let str = JSON.stringify({
                chargeId: this.payBody.chargeId,
                studentId: this.payBody.studentId,
                fromtype: "7",
              });
              let s = publicEncrypt(str);
              this.$router.push({
                path: "/pages/results/results?vde=" + this.vde + "&s=" + s,
              });
            } else if (result.length == 1) {
              // 1条数据时，直接调支付
              let info = {
                billInterfaceType: result[0].billInterfaceType,
                bizDatas: [
                  {
                    bizId: result[0].uId,
                    sysType: result[0].sysType,
                    deptId: result[0].deptId,
                  },
                ],
                deviceType: "phone",
                isPolice: false,
                payAmt: result[0].paymentTotal,
                payerName: result[0].paymentName,
              };
              // Toast.loading({
              //   message: "加载中...",
              //   forbidClick: true,
              //   duration: 0,
              // });
              // setTimeout(() => {
              //     Toast.clear();
              // }, 1000);
              this.showChooseCharge = false;
              if (
                result[0].merchantType == "001" ||
                result[0].merchantType == "002" ||
                result[0].merchantType == "003" ||
                result[0].merchantType == "015" ||
                result[0].merchantType == "016"||
                result[0].merchantType == "017"
              ) {
                this.remitPayRequest(info);
              } else {
                this.pay(info);
              }
            }
            if (res.data.message) {
              // this.showErr = true;
              // this.notice = res.data.message;
              this.$CDialog({
                confirmBtnText: "确认",
                title: "提示",
                status: "2",
                textSize: 16,
                message: res.data.message,
              }).then((res) => {});
              // Dialog.alert({
              //   title: "提示",
              //   message: res.data.message,
              // }).then(() => {});
            }
          } else {
            Toast.clear();
            // Dialog.alert({
            //   title: "提示",
            //   message: res.data.message,
            // }).then(() => {
            //   this.isPay = false;
            // });
            // this.showErr = true;
            // this.notice = res.data.message;
            let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message,
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false,
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message,
              });
            }
            this.isPay = false;
            return;
          }
        });
      }
    },
    // 重置学校收费项dialog
    resetPayBody: function () {
      this.payBody = {
        chargeId: "",
        periodName: "",
        quarterName: "",
        actualTotal: "",
        startDate: "",
        endDate: "",
        studentId: "",
      };
    },
    onClickLeft() {
      this.$router.push({
        path: "/paymain",
        query: {
          deptId: this.info.deptId,
          vde: this.vde,
          name: this.info.name,
          idCard: this.info.idCard,
        },
      });
    },
    asyncLoadJs(url) {
      var Q = require("q");
      return Q.Promise((resolve, reject) => {
        let srcArr = document.getElementsByTagName("script");
        let hasLoaded = false;
        for (let i = 0; i < srcArr.length; i++) {
          //判断当前js是否加载上
          hasLoaded = srcArr[i].src == url ? true : false;
        }
        if (hasLoaded) {
          resolve();
          return;
        }
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject();
        };
      });
    },
    contPay(uId) {
      this.currentPayData = null;
      this.bool = false;
      this.payBody.chargeId = uId;
      // console.log(uId);
      this.payBody.studentId = this.info.uId;
      // console.log(uId, this.info.uId);
      if (!isEmpty(this.payBody.chargeId)) {
        this.chargeList.forEach((it) => {
          if (it.uId == uId) {
            this.currentPayData = it;
          }
        });
      }
      if (this.currentPayData) {
        this.bool = this.currentPayData.prompt;
      }
      if (this.bool) {
        if (isEmpty(this.payBody.chargeId)) {
          Toast.clear();
          // this.showErr = true;
          // this.notice = "请选择需要支付的收费项";
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: "请选择需要支付的收费项",
          }).then((res) => {});
          this.isPay = false;
          // Dialog.alert({
          //   title: "错误提示",
          //   message: "请选择需要支付的收费项",
          // }).then(() => {
          //   this.isPay = false;
          // });
          return;
        }
        // 弹出支付提示
        this.showDialog = true;
      } else {
        this.chargePay();
      }

      // Dialog.confirm({
      //   background: "#fff",
      //   title: "支付提示",
      //   message: `您还有1项费用未支付，是否前去缴费`,
      //   confirmButtonText: "继续支付",
      //   confirmButtonColor: "#00b4fa",
      //   cancelButtonText: "返回",
      //   cancelButtonColor: "#666666",
      //   getContainer: ".nucleicAcidTestMain",
      // })
      //   .then(() => {
      //     // on confirm
      //   })
      //   .catch(() => {
      //     // on cancel
      //   });
    },
    handleScroll(e) {
      const top = e.target.scrollTop;
      if (top > 0) {
        this.flag = true;
      } else {
        this.flag = false;
      }
    },
    // 初始化来源，判断是否在微信小程序内
    initFrom() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            this.isWxmp = true;
          } else {
          }
        });
      } else {
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    setTimeout(() => {
      if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
        document.addEventListener("WeixinJSBridgeReady", ready, false);
      } else {
        ready();
      }
      function ready() {
        if (window.__wxjs_environment === "miniprogram") {
          WeixinJSBridge.on("onPageStateChange", function (res) {
            // todo 查询订单支付状态 等逻辑决定是否需要跳转页面
            if (res.active === "true" || res.active === true) {
              window.localStorage.setItem("wxmpBack", "1");
              window.localStorage.setItem("isWxmp", "1");
              let num = new Date().getTime() + Math.floor(Math.random());
              let reslut = window.location.href.indexOf("nowTime");
              if (reslut == -1) {
                window.location.href = window.location.href + "&nowTime=" + num;
              } else {
                let str = window.location.href.slice(0, reslut);
                window.location.href = window.location.href + "&nowTime=" + num;
              }
            }
          });
        }
      }
    }, 0);
  },
  created() {
    if (this.$route.query.vde === undefined) {
      this.vde = "";
    } else {
      this.vde = this.$route.query.vde;
    }
    if (this.$route.params.out) {
      sessionStorage.setItem("out", this.$route.params.out);
    }
    this.initFrom();
    // console.log(this.$route.query);
    //判断vde
    judgeVde({ vde: this.vde }, this);
    // 直接在进入页面的时候就可以获取到 deptId,去查询缴费项
    this.info = this.$route.query; // 暂时需要 uid和 deptId
    this.goChoosePay(this.info);
  },
};
</script>

<style lang="scss" scoped>
.white_space {
  min-height: 110vh;
  background: #fff;
}
.nucleicAcidTestMaind {
  box-sizing: border-box;
  height: 100vh;
  overflow-y: auto;
  background: url("../../assets/img/queryBW.png") no-repeat;
  background-color: #fff;
  background-size: cover;
  .paySearch {
    position: relative;
    box-sizing: border-box;
    width: 315px;
    height: 36px;
    margin: 10px auto;
    margin-bottom: 16px;
    padding-left: 36px;
    background: #ffffff;
    border-radius: 22px;
    .searchPic {
      position: absolute;
      top: 18px;
      left: 20px;
      width: 18px;
      height: 18px;
      transform: translateY(-50%);
    }
    ::v-deep .van-cell {
      height: 36px;
      padding: 6px 0.42667rem;
      border-radius: 22px;
      .van-field {
        padding: 0px;
      }
    }
  }
  ::v-deep .van-nav-bar__title {
    color: #fff !important;
    color: #ffffff;
    font-weight: 600;
    font-size: 17px;
    font-family: PingFangSC-Semibold;
    letter-spacing: 0;
    text-align: center;
  }
  ::v-deep .van-nav-bar__left .van-icon {
    color: #fff;
  }
}
.nucleicAcidTestMaind {
  ::v-deep .van-hairline--bottom::after {
    border-bottom: none;
  }
  ::v-deep .van-radio-group {
    // padding-bottom: 68px;
  }
  ::v-deep.van-search {
    width: 315px;
    height: 36px;
    margin: 10px auto;
    margin-bottom: 0px;
    background-color: transparent !important;
    .van-field__control {
      color: #cccccc;
      font-weight: 400;
      font-size: 13px;

      letter-spacing: 0;
    }
  }
  ::v-deep .van-search__content {
    background-color: #fff !important;
  }
  padding-top: 46px;
  padding-bottom: 60px !important;
  ::v-deep .van-dialog__header {
    padding-top: 12px;
    padding-bottom: 11px;
    color: #fff !important;
    background: #1989fa !important;
  }
  .van-nav-bar {
    ::v-deep .van-icon {
      font-size: 18px;
    }
  }
  .notr {
    background: transparent;
  }
  .trans {
    background: #2e97ff;
  }
  ::v-deep .van-nav-bar {
    // background: #2e97ff !important;
    .van-icon {
      color: #fff;
    }
    .van-nav-bar__title {
      color: #fff;
    }
  }

  @media screen and (min-width: 374px) {
    .pbox {
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      padding: 0 12px;
      .van-radio {
        align-items: flex-start;
        padding-top: 26px;
      }
    }
    .pbottom {
      width: 345px;
      padding: 17px 15px;
      button {
        width: 150px;
        height: 44px;
        font-size: 18px;
      }
      span {
        font-size: 20px;
      }
    }
  }
  @media screen and (max-width: 374px) {
    .pbox {
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      padding: 0 12px;
      .van-radio {
        align-items: flex-start;
        padding-top: 26px;
      }
    }
    .pbottom {
      width: calc(100% - 90px);
      padding: 17px 45px;
      button {
        width: 120px;
        height: 30px;
        font-size: 14px;
      }
      span {
        font-size: 16px;
      }
    }
  }
}
.sele {
  color: #00b4fa !important;
  ::v-deep .header {
    .c_bottom {
      color: #00b4fa;
      .top {
        color: #00b4fa;
      }
    }
  }
}
.pbottom {
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  color: #2e3133;

  font-size: 14px;
  background: #fff;
  div {
    align-self: center;
  }
  span {
    margin-left: 10px;
    color: #f7b500;
  }
  button {
    align-self: center;
    color: #fff;
    background: #00b4fa;
    border: none;
    border-radius: 7px;
  }
}
.bot {
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  background: #fff;
  .total {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-right: 10px;
    line-height: 50px;
  }
  .b_btn {
    width: 90px;
    height: 40px;
    margin-left: 20px;
  }
  .b_tot {
    color: #333;
    font-size: 12px;
  }
  .b_total {
    .yang {
      margin-right: 4px;
      font-size: 12px;
    }
    color: #ff5e5d;
    font-weight: bold;
    font-size: 18px;
  }
}
.noconfig_class {
  margin-top: 20px;
  color: #fff;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
}
.noticeMessEnter {
  margin-bottom: 12px;
  padding-top: 8px;
  color: #888888;
  font-weight: 400;
  font-size: 14px;

  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
}
.noticeMess {
  margin-bottom: 12px;
  padding-top: 8px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.enter {
  color: #006ade;
}

.btnBoxPay {
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  height: 64px;
  padding: 0 10px;
  background: #fff;
  ::v-deep .van-button--info {
    border: none !important;
    outline: none !important;
  }
  > div {
    width: 60%;
    > span:nth-of-type(1) {
      font-size: 14px;
    }
    > span:nth-of-type(2) {
      color: #f7b500;
      font-size: 20px;
    }
  }
  .totalWord {
    display: flex;
    align-items: center;
    color: #464a4c;
    font-weight: 400;
    font-size: 12px;

    letter-spacing: 0;
    .word {
      color: #464a4c;
      font-weight: 400;
      font-size: 16px;

      letter-spacing: 0;
    }
    .mon {
      color: #f46c6c;
      font-weight: 500;
      font-size: 18px;

      letter-spacing: 0;
    }
  }
  .btn {
    width: 100px;
    height: 40px;
    color: #ffffff;
    font-weight: 500;
    font-size: 16px;

    letter-spacing: 0;
    text-align: center;
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 22px;
  }
}
</style>
